import { useState } from 'react';
import { withLoading } from '@front-activerse/common-components';
import Layout from '../../Layout/Layout';
import { useTranslator } from '@front-activerse/common-components';
import Dish from '../../MealPlan/MealView/components/DayPlanDish';
import IngredientList from '../../MealPlan/MealView/components/DayPlanIngredientList';
import Ingredient from './FavMealIngredient';
import DietetiansAdvice from '../../MealPlan/MealView/components/DayPlanDietetiansAdvice';
import FavMealDetails from './FavMealDetails';
import InsertToDayPlan from '../Common/InsertMealToDayPlan';
import UniversalPlaceholder from '../../Layout/UniversalPlaceholder';
import TitleBar from '../../Layout/TitleBar';
import { useOutletContext } from 'react-router-dom';
import { DietMealReplaceProductConnectorApollo } from '@front-activerse/common-components';
import IngredientReplacementList from './FavMealIngredientReplacementList';
import IngredientReplacement from './FavMealIngredientReplacement';

const FavMealContainer = ({
  lastAvailableDay,
  favMeal,
  addMealToFavorites,
  insertFavoriteToDayplan,
  removeMealFromFavorites,
  rateMeal,
  refetch,
}) => {
  const { t } = useTranslator();
  const [mealId, setMealId] = useState(undefined);
  const [showInsertDate, setShowInsertDate] = useState(false);
  const { trackFirebaseEvent } = useOutletContext();

  const openInsertDate = (mealId) => {
    if (mealId) {
      setMealId(mealId);
      setShowInsertDate(true);

      trackFirebaseEvent('user_action', {
        action: 'tap-add_to_diet',
        meal_id: mealId,
      });
    }
  };

  const closeInsertDate = () => {
    setShowInsertDate(false);
    setMealId(undefined);
  };

  const renderIngredientReplacements = (replacements, productAmountId, productId, clickAction) =>
    replacements.map((replacement) => (
      <DietMealReplaceProductConnectorApollo key={replacement.productId}>
        {({ replaceProduct }) => (
          <IngredientReplacement
            replacementId={replacement.productId}
            name={replacement.name}
            measurements={replacement.measurements}
            replaceProduct={replaceProduct}
            productId={productId}
            productAmountId={productAmountId}
            replaceProductSuccess={clickAction.closeAndScroll}
            refetch={refetch}
          />
        )}
      </DietMealReplaceProductConnectorApollo>
    ));

  const renderIngredientReplacementsList = (
    replacements,
    originalProductId,
    productId,
    original,
    productAmountId,
    clickAction
  ) => (
    <IngredientReplacementList
      shouldRenderOryginalProduct={originalProductId !== productId}
      renderOriginalProduct={() =>
        renderIngredientReplacements([original], productAmountId, productId, clickAction)
      }
      hasReplacements={replacements.length > 0}
    >
      {() => renderIngredientReplacements(replacements, productAmountId, productId, clickAction)}
    </IngredientReplacementList>
  );

  const renderIngredients = (ingredients) =>
    ingredients.map((ingredient) => (
      <Ingredient
        key={ingredient.productId}
        name={ingredient.name}
        measurements={ingredient.measurements}
        saleProductVariant={ingredient.saleProductVariant}
        hasReplacement={ingredient.hasReplacement}
        originalProductId={ingredient.original.productId}
        productId={ingredient.productId}
        productKey={ingredient.key}
      >
        {({ closeAndScroll }) =>
          renderIngredientReplacementsList(
            ingredient.replacements,
            ingredient.original.productId,
            ingredient.productId,
            ingredient.original,
            ingredient.productAmountId,
            { closeAndScroll }
          )
        }
      </Ingredient>
    ));

  const renderIngredientList = (ingredients) => {
    const filteredIngredients = ingredients.filter(
      (ingredient) => !ingredient.category.isSeasoning && !ingredient.category.isOptional
    );

    const onlySeasoningsIngredients = ingredients.filter(
      (ingredient) => ingredient.category.isSeasoning
    );

    const optionalIngredients = ingredients.filter((ingredient) => ingredient.category.isOptional);

    return (
      <IngredientList
        renderIngredients={() => renderIngredients(filteredIngredients)}
        renderOnlySeasoningsIngredients={() => renderIngredients(onlySeasoningsIngredients)}
        renderOptionalIngredients={() => renderIngredients(optionalIngredients)}
      />
    );
  };

  const renderDishes = (dishes) =>
    dishes.map((dish) => (
      <Dish
        key={dish.id}
        name={dish.name}
        recipe={dish.recipe}
        recipeNote={dish.recipeNote}
        // isFirstOccurance={dish.isFirstOccurance}
        // isLastOccurance={dish.isLastOccurance}
        // isPortioned={dish.isPortioned}
        // portions={dish.portions}
        // portionsTotal={dish.portionsTotal}
      >
        {() => renderIngredientList(dish.ingredients)}
      </Dish>
    ));

  const dietitiansAdvice = (dishes) => {
    const adviceArray = [];

    dishes.forEach((dish) => {
      dish.ingredients.forEach((ingredient) => {
        if (ingredient.note.title) {
          adviceArray.push({
            title: ingredient.note.title,
            description: ingredient.note.content,
            media: ingredient.note.media,
          });
        }
      });
    });

    if (adviceArray.length > 0) {
      return <DietetiansAdvice advices={adviceArray} />;
    }

    return null;
  };

  return (
    <Layout>
      <TitleBar level={1}>{t('mealPlan.favorites.mealDetails.navbarTitle')}</TitleBar>
      <div className="page-template-meal-plan">
        <FavMealDetails
          toggleInsertDate={(mealId) => openInsertDate(mealId)}
          removeMealFromFavorites={removeMealFromFavorites}
          addMealToFavorites={addMealToFavorites}
          meal={favMeal}
          rateMeal={rateMeal}
          refetch={refetch}
        >
          {() => (
            <>
              {renderDishes(favMeal.dishes)}
              {dietitiansAdvice(favMeal.dishes)}
            </>
          )}
        </FavMealDetails>

        <InsertToDayPlan
          lastAvailableDay={lastAvailableDay}
          showInsertDate={showInsertDate}
          mealId={mealId}
          insertFavoriteToDayplan={insertFavoriteToDayplan}
          closeInsertDate={() => closeInsertDate()}
        />
      </div>
    </Layout>
  );
};

export default withLoading(FavMealContainer, UniversalPlaceholder);
